import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { MDXRenderer } from '../../../../../hoc/components';

const CopayTerms: React.FC = () => {
	const data = useStaticQuery(
		graphql`
			{
				mdx(internal: { contentFilePath: { regex: "/terms/copay/" } }) {
					body
				}
			}
		`
	);

	return <MDXRenderer>{data.mdx.body}</MDXRenderer>;
};

export default CopayTerms;